const LOCALE = "en-US";

const formatterAutoInteger = new Intl.NumberFormat(LOCALE, {
  useGrouping: true,
  maximumFractionDigits: 0,
});

const formatterAutoDecimal = new Intl.NumberFormat(LOCALE, {
  useGrouping: true,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatterFixed2 = new Intl.NumberFormat(LOCALE, {
  useGrouping: true,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatChartNumber(
  value: number,
  mode: "auto" | "fixed2"
): string {
  if (!Number.isFinite(value)) {
    return String(value);
  }
  if (mode === "fixed2") {
    return formatterFixed2.format(value);
  }
  if (Number.isInteger(value)) {
    return formatterAutoInteger.format(value);
  }
  return formatterAutoDecimal.format(value);
}

export function formatAxisTick(value: number | string): string {
  if (typeof value === "string" && Number.isNaN(Number(value))) {
    return value;
  }
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return String(value);
  }
  return formatChartNumber(num, "auto");
}
